import React from 'react'
import PropTypes from 'prop-types'

const LandingInfoBlocks = ({ block }) => {
  const { infoBlocks, className } = block
  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 pt-5 p-lg-5 d-flex flex-column flex-lg-row align-items-center'>
        {infoBlocks.map((d, i) => {
          return (
            <div className='col px-5 px-md-0 pb-5 pb-lg-4 pe-5 pt-3' key={i}>
              <div className='text-primary'>
                <p className='h5' data-cy='landing-info-title'>{d.title}</p>
              </div>
              <div className='mt-3 pe-5' data-cy='landing-info-description'><div dangerouslySetInnerHTML={{ __html: d.description }} /></div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

LandingInfoBlocks.propTypes = {
  block: PropTypes.object
}

export default LandingInfoBlocks
